import { render, staticRenderFns } from "./Folk-collection.vue?vue&type=template&id=6a47dcdd&scoped=true"
import script from "./Folk-collection.vue?vue&type=script&lang=js"
export * from "./Folk-collection.vue?vue&type=script&lang=js"
import style0 from "./Folk-collection.vue?vue&type=style&index=0&id=6a47dcdd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a47dcdd",
  null
  
)

export default component.exports